import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-668962ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 pd-offer-card pd-recovery-banner"
}
const _hoisted_2 = { class: "card-body d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 p-4 p-md-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pd-recovery-kicker mb-2" }, "Oferta exclusiva ainda ativa", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-2 pd-card-title" }, "Ainda dá para aproveitar o desconto!", -1))
const _hoisted_5 = { class: "mb-0 pd-card-subtitle" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Seu acesso PRO continua com valor promocional: ")
const _hoisted_7 = { class: "pd-old-price" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" por ")
const _hoisted_9 = { class: "pd-highlight-price" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pd-card-proof mb-0 mt-1" }, "Oferta por tempo limitado para novos assinantes.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pd-backdrop",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_13 = { class: "pd-confetti-anchor" }
const _hoisted_14 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_15 = { class: "modal-content pd-modal-content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header pd-modal-header border-0 pb-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pd-badge mb-1" }, "Parabéns, você desbloqueou um desconto!"),
  /*#__PURE__*/_createElementVNode("h4", {
    class: "modal-title w-100 mt-2",
    id: "pdModalTitle"
  }, " Assine o plano PRO com preço promocional "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted pd-modal-subtitle mt-1 mb-3" }, " Acesso completo aos labs, certificacoes e trilhas com valor promocional por tempo limitado. ")
], -1))
const _hoisted_17 = { class: "modal-body pt-3 pb-2" }
const _hoisted_18 = { class: "pd-price-block" }
const _hoisted_19 = { class: "pd-price-original text-decoration-line-through" }
const _hoisted_20 = { class: "pd-price-final" }
const _hoisted_21 = { class: "pd-discount-percent mt-1" }
const _hoisted_22 = { class: "pd-savings-badge mt-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pd-modal-proof mt-3 mb-0" }, " Essa condicao pode expirar sem aviso. ", -1))

import { ref, computed, watch, nextTick } from "vue";
import ConfettiExplosion from "vue-confetti-explosion";
import type { IProgressiveDiscount } from "@/modern/composables/useDashboardPage";


export default /*#__PURE__*/_defineComponent({
  props: {
    discount: null
  },
  setup(__props: any) {

const props = __props as {
  discount: IProgressiveDiscount | null;
}



const DECLINE_SESSION_KEY = "progressive_discount_declined";

const isOpen = ref(false);
const showConfetti = ref(false);
const showRecoveryBanner = ref(false);
const hasDeclinedThisSession = ref(false);

const isEligible = computed(
  () => props.discount !== null && props.discount?.has_discount === true
);

const formatBRL = (cents: number) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(cents / 100);

const savings = computed(() => {
  if (!props.discount?.has_discount) return 0;
  return props.discount.plan.value_cents - props.discount.plan.final_value_cents;
});

const discountPercent = computed(() => {
  if (!props.discount?.has_discount) return 0;

  const original = props.discount.plan.value_cents;
  if (original <= 0) return 0;

  const result = Math.round((savings.value / original) * 100);
  return Number.isFinite(result) ? Math.max(result, 0) : 0;
});

const funnelEvent = (eventName: string) => {
  window.dispatchEvent(
    new CustomEvent("progressive-discount-funnel", {
      detail: {
        event: eventName,
        planId: props.discount?.has_discount ? props.discount.plan.identifier : null,
        timestamp: Date.now(),
      },
    })
  );
};

const readDeclineSession = (): boolean => {
  try {
    return sessionStorage.getItem(DECLINE_SESSION_KEY) === "1";
  } catch {
    return false;
  }
};

const writeDeclineSession = (value: boolean) => {
  try {
    if (value) {
      sessionStorage.setItem(DECLINE_SESSION_KEY, "1");
      return;
    }

    sessionStorage.removeItem(DECLINE_SESSION_KEY);
  } catch {
    // Fail silently when sessionStorage is unavailable.
  }
};

const openModal = async () => {
  if (!props.discount?.has_discount) return;

  isOpen.value = true;
  showRecoveryBanner.value = false;
  showConfetti.value = false;
  funnelEvent("modal_opened");
  await nextTick();
  setTimeout(() => {
    showConfetti.value = true;
  }, 300);
};

watch(
  isEligible,
  async (eligible) => {
    if (!eligible) {
      isOpen.value = false;
      showConfetti.value = false;
      showRecoveryBanner.value = false;
      hasDeclinedThisSession.value = false;
      writeDeclineSession(false);
      return;
    }

    hasDeclinedThisSession.value = readDeclineSession();

    if (hasDeclinedThisSession.value) {
      isOpen.value = false;
      showConfetti.value = false;
      showRecoveryBanner.value = true;
      funnelEvent("recovery_banner_shown");
      return;
    }

    if (!isOpen.value) {
      await openModal();
    }
  },
  { immediate: true }
);

const closeModal = () => {
  isOpen.value = false;
  showConfetti.value = false;
  hasDeclinedThisSession.value = true;
  writeDeclineSession(true);
  showRecoveryBanner.value = true;
  funnelEvent("modal_declined");
  funnelEvent("recovery_banner_shown");
};

const claimOffer = () => {
  funnelEvent(isOpen.value ? "modal_claim_clicked" : "recovery_banner_claim_clicked");
  window.open("https://pay.hackingclub.com/cart/pro", "_blank");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showRecoveryBanner.value && __props.discount?.has_discount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("p", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", _hoisted_7, _toDisplayString(formatBRL(__props.discount.plan.value_cents)), 1),
                _hoisted_8,
                _createElementVNode("strong", _hoisted_9, _toDisplayString(formatBRL(__props.discount.plan.final_value_cents)), 1),
                _hoisted_10
              ]),
              _hoisted_11
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn pd-btn-primary pd-card-cta",
              onClick: claimOffer
            }, " Quero aproveitar ")
          ])
        ]))
      : _createCommentVNode("", true),
    (isOpen.value && __props.discount?.has_discount)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_12,
          _createElementVNode("div", {
            class: "modal show pd-modal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "pdModalTitle",
            "aria-modal": "true",
            style: {"display":"block"},
            onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["esc"]))
          }, [
            _createElementVNode("div", _hoisted_13, [
              (showConfetti.value)
                ? (_openBlock(), _createBlock(_unref(ConfettiExplosion), {
                    key: 0,
                    particleCount: 120,
                    force: 0.4
                  }, null, 8, ["force"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, " De " + _toDisplayString(formatBRL(__props.discount.plan.value_cents)), 1),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(formatBRL(__props.discount.plan.final_value_cents)), 1),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(discountPercent)) + "% OFF ", 1),
                    _createElementVNode("div", _hoisted_22, " Você economiza " + _toDisplayString(formatBRL(_unref(savings))), 1),
                    _hoisted_23
                  ])
                ]),
                _createElementVNode("div", { class: "modal-footer flex-column align-items-center gap-2 border-0 pt-0 pb-4" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn w-100 pd-btn-primary pd-btn-claim",
                    onClick: claimOffer
                  }, " Quero garantir meu desconto "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-link pd-btn-decline",
                    onClick: closeModal
                  }, " Deixar passar ")
                ])
              ])
            ])
          ], 32)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})